import React from 'react';
import { useTheme } from '../theme/ThemeContext';

export default function KPICard({ title, value, delta, prefix = '', suffix = '', dimmed = false }) {
  const { theme } = useTheme();
  const formatted = typeof value === 'number'
    ? prefix + value.toLocaleString('ru-RU', { maximumFractionDigits: 1 }) + suffix
    : value || '—';
  const deltaColor = delta > 0 ? 'var(--success)' : delta < 0 ? 'var(--danger)' : 'var(--text-muted)';
  const deltaClass = delta > 0 ? 'delta-up' : delta < 0 ? 'delta-down' : 'delta-flat';
  const deltaText = delta != null ? `${delta > 0 ? '↑ +' : delta < 0 ? '↓ ' : ''}${delta.toFixed(1)}%` : null;

  return (
    <div
      style={{
        background: 'var(--surface-sheen), var(--bg-card)',
        border: '1px solid var(--border)',
        borderRadius: 14,
        padding: '16px 18px',
        flex: '1 1 160px',
        minWidth: 140,
        boxShadow: 'var(--card-rest)',
        transition: 'transform 0.25s cubic-bezier(0.22, 1, 0.36, 1), box-shadow 0.25s ease, border-color 0.2s ease',
        cursor: 'default',
        opacity: dimmed ? 0.55 : 1,
        pointerEvents: dimmed ? 'none' : 'auto',
      }}
      onMouseEnter={(e) => {
        if (dimmed) return;
        e.currentTarget.style.borderColor = 'var(--border-hover)';
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = 'var(--card-hover)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = 'var(--border)';
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'var(--card-rest)';
      }}
    >
      <div style={{
        color: 'var(--text-muted)', fontSize: 11, fontWeight: 600,
        textTransform: 'uppercase', letterSpacing: 1.1,
        fontFamily: theme.fontBody,
      }}>
        {title}
      </div>
      <div
        className="tabular-nums"
        style={{
          color: 'var(--text-primary)',
          fontSize: 24,
          fontWeight: 700,
          marginTop: 8,
          fontFamily: theme.fontDisplay,
          letterSpacing: '-0.02em',
        }}
      >
        {formatted}
      </div>
      {deltaText && (
        <div
          className={deltaClass}
          style={{
            fontSize: 12,
            fontWeight: 600,
            marginTop: 8,
            display: 'inline-block',
            padding: '3px 8px',
            borderRadius: 6,
            background: deltaColor + '18',
            fontVariantNumeric: 'tabular-nums',
          }}
        >
          {deltaText}
        </div>
      )}
    </div>
  );
}
